export const heightBottomNav=0;
export const DefaultLayoutZIndex=7888999
export const variantHeading = {
    xs: "h4",
    sm: "h3",
    md: "h3",
    lg: "h2",
    xl: "h2",
    xxl: "h1",
  };
  export const variantBody = {
    xs: "body2",
    sm: "body2",
    md: "body2",
    lg: "body1",
    xl: "body1",
    xxl: "body1",
  };